var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-moment-box"},[_c('chat-moment',{key:"ChatInfoChatMoment",attrs:{"friend":_vm.friend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }